import { useTranslation } from "./i18n";
import type { courseworkClassSummary } from "./lib/courseworkSummary";
import "./agenda-coursework.css";

export default function AgendaCourseworkSummary({
  rows,
  scope,
  onOpenClass,
}: {
  rows: ReturnType<typeof courseworkClassSummary>;
  scope?: string;
  onOpenClass: (classId: string) => void;
}) {
  const { t } = useTranslation("personalTools");
  if (!rows.length) return null;
  const tasks = rows.reduce((sum, row) => sum + row.count, 0);
  return (
    <details className="agenda-coursework">
      <summary>
        <span className="agenda-coursework-heading">
          <strong>{t("coursework.title")}</strong>
          {scope && <small>{scope}</small>}
        </span>
        <span className="agenda-coursework-total">
          {t("coursework.total", { classes: rows.length, tasks })}
          <svg viewBox="0 0 20 20" aria-hidden="true">
            <path d="m5 8 5 5 5-5" />
          </svg>
        </span>
      </summary>
      <ul>
        {rows.map(({ classroom, count }) => (
          <li key={classroom.id}>
            <button
              type="button"
              onClick={() => onOpenClass(classroom.id)}
              aria-label={t("coursework.openClass", { name: classroom.name, count })}
            >
              <span>{classroom.name}</span>
              <span className="agenda-coursework-count">
                {t("coursework.tasks", { count })}
                <span aria-hidden="true">→</span>
              </span>
            </button>
          </li>
        ))}
      </ul>
    </details>
  );
}
